import { render, staticRenderFns } from "./ExternalCalendar.vue?vue&type=template&id=e74e3ec2"
import script from "./ExternalCalendar.vue?vue&type=script&lang=js"
export * from "./ExternalCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports